import React from 'react'
import { Card, Image } from 'semantic-ui-react'
import listOfCars from './supercars-data.csv'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'

import './styles.scss'

function SupercarCards(props) {
  // if (this.state.cards.length > 0)

  let sortedCards = listOfCars.sort((a, b) => a['Nr'] - b['Nr'])

  return sortedCards.map((c, index) => {
    // set status
    let carFound = false
    let pictureOriginal = false

    if (c.status.toLowerCase().indexOf('trouvée') !== -1) {
      carFound = true
    }

    if (c.picturelegende.toLowerCase().indexOf('originale') !== -1) {
      pictureOriginal = true
    }
    if (props.Kategorie === c.category) {
      return (
        <Card
          key={c.category + index}
          className={carFound ? 'found' : 'missing'}
        >
          {carFound && (
            <div className='iconWrapper'>
              <span className='check'>{c.status}</span>
            </div>
          )}

          <div className='teaserContainer'>
            <Image src={require(`./img/${c.Teaser}`)} />
            {pictureOriginal && (
              <div className='iconWrapper'>
                <span
                  className='car'
                  dangerouslySetInnerHTML={{ __html: c.picturelegende }}
                />
              </div>
            )}
          </div>

          <Card.Content className='carsCardContent'>
            <Card.Header>
              <div className='headerContainer'>
                <div className='carTitle'>
                  <div className='carBrand'>{c.constructor}</div>
                </div>
                <div className='imageContainer'>
                  <Image
                    className='ui fluid image'
                    src={require(`./img/${c.Icon}.svg`)}
                  />
                </div>
              </div>
            </Card.Header>
            <Card.Meta>
              <span className='carTyp'>{c.type}</span>
            </Card.Meta>

            {/*
                      <Card.Description>
                        <table className='ui fixed small very compact definition unstackable table'>
                          <tbody>
                            <tr className='title six wide top aligned'>
                              <td>Preis</td>
                              <td>{c.Preis}</td>
                            </tr>
                            <tr className='title six wide top aligned'>
                              <td>Kennzeichen</td>
                              <td>{c.Schild_1}</td>
                            </tr>
                          </tbody>
                        </table>
                      </Card.Description> */}
          </Card.Content>
          <table className='ui fixed small very compact attached definition unstackable table cars'>
            <tbody>
              <tr className='title six wide top aligned'>
                <td>Prix</td>
                <td>{c.price}</td>
              </tr>
              <tr className='title six wide top aligned'>
                <td>Couleur</td>
                <td>{c.color}</td>
              </tr>

              <tr className='title six wide top aligned'>
                <td colSpan='2'>
                  Immatriculation <br />
                  <div
                    className='kennzeichen'
                    dangerouslySetInnerHTML={{
                      __html:
                        c.Schild_1 +
                        ' ' +
                        c.Schild_2 +
                        ' ' +
                        c.Schild_3 +
                        ' ' +
                        c.Schild_4 +
                        ' ' +
                        c.Schild_5
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          {/* <Card.Content extra>
                    </Card.Content> */}
        </Card>
      )
    }
  })
}

export default SupercarCards
